module.exports = __webpack_public_path__ + "images/7739d821b1eb07b2d15319bd7da43148.svg";